"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalState = exports.ModalStatus = void 0;
const react_1 = require("react");
var ModalStatus;
(function (ModalStatus) {
    ModalStatus["CLOSED"] = "CLOSED";
    ModalStatus["OPEN"] = "OPEN";
})(ModalStatus || (exports.ModalStatus = ModalStatus = {}));
function useModalState(initialModalStatus = ModalStatus.CLOSED) {
    const [modalStatus, setModalStatus] = (0, react_1.useState)(initialModalStatus);
    function openModal() {
        setModalStatus(ModalStatus.OPEN);
    }
    function closeModal() {
        setModalStatus(ModalStatus.CLOSED);
    }
    return {
        modalStatus,
        setModalStatus,
        modalIsClosed: modalStatus === ModalStatus.CLOSED,
        modalIsOpen: modalStatus === ModalStatus.OPEN,
        openModal,
        closeModal,
    };
}
exports.useModalState = useModalState;
//# sourceMappingURL=useModalState.js.map